import React from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';

import { JobListEntry } from './';
import { getJobsFilteredByCategoryAndLocation } from '../../../lib/greenHouse/greenHouseApi';

const JobListContainer = styled('div')`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  align-content: flex-start;
`;

const JobsListHeader = styled('div')`
  display: flex;
  width: 100%;
  margin: 2rem 1rem;
`;

export const JobList = ({
  handler,
  selectedCategory,
  selectedLocation,
  jobs,
}: {
  handler: any;
  selectedCategory: string | undefined;
  selectedLocation: string | undefined;
  jobs: any[];
}): JSX.Element => {
  const filteredJobs = getJobsFilteredByCategoryAndLocation(
    jobs,
    selectedCategory ? selectedCategory : 'all',
    selectedLocation ? selectedLocation : 'all',
  );

  return (
    <Container maxWidth="lg">
      <JobListContainer>
        <>
          {filteredJobs.length > 0 && (
            <>
              <JobsListHeader>
                <Typography variant="h4">
                  {filteredJobs.length} Jobs gefunden
                </Typography>
              </JobsListHeader>
              {filteredJobs.map((job: any) => (
                <JobListEntry key={job.id} job={job} handler={handler} />
              ))}
            </>
          )}

          {filteredJobs.length === 0 && (
            <div>
              <Typography variant="h4" style={{ margin: '2rem 1rem' }}>
                Keine Jobs gefunden
              </Typography>
              <p>
                Es wurden keine Jobs gefunden, die den gewählten Kriterien
                entsprechen.
              </p>
            </div>
          )}
        </>
      </JobListContainer>
    </Container>
  );
};
